import React from 'react';
import { motion } from 'framer-motion';
export function OtlParamoExample() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mb-24 grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden" data-id="element-319">
      <div className="lg:col-span-5 relative min-h-[300px] lg:min-h-0" data-id="element-320">
        <img src="https://cdn.magicpatterns.com/uploads/b3XxDpPc3kRjBQ4H7ZEj2X/paramo.jpg" alt="Páramo andino con frailejones" className="absolute inset-0 w-full h-full object-cover" data-id="element-321" />
      </div>
      <div className="lg:col-span-7 p-8 md:p-12 lg:p-16" data-id="element-322">
        <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold mb-3 block" data-id="element-323">
          Un ejemplo sencillo
        </span>
        <h3 className="font-serif text-3xl md:text-4xl mb-6 leading-tight" data-id="element-324">
          Los páramos
        </h3>
        <div className="space-y-4 text-bone/80 font-light leading-relaxed mb-10" data-id="element-325">
          <p data-id="element-326">
            Los páramos son ecosistemas de alta montaña fundamentales para la
            vida. Tienen una gran capacidad para captar, almacenar y regular el
            agua, por lo que abastecen a millones de personas y cumplen un papel
            clave frente al cambio climático.
          </p>
          <p data-id="element-327">
            Cuando un páramo se reconoce y delimita como OTL, su protección deja
            de ser una idea general y se convierte en una regla concreta sobre
            el territorio. Esto permite identificar sus límites, conocer la
            norma que lo respalda y orientar las decisiones públicas y privadas
            que puedan afectarlo.
          </p>
          <p data-id="element-328">
            En estos casos, los OTL permiten reconocer tres elementos
            principales:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-329">
          <div data-id="element-330">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-331">
              Derechos
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-332">
              Asociados a la protección del agua, la biodiversidad y los
              servicios ecosistémicos que benefician a la sociedad.
            </p>
          </div>
          <div data-id="element-333">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-334">
              Restricciones
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-335">
              Relacionadas con actividades que pueden afectar el equilibrio
              ambiental, como ciertos usos mineros, urbanísticos o productivos.
            </p>
          </div>
          <div data-id="element-336">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-337">
              Responsabilidades
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-338">
              Compartidas entre el Estado, las comunidades y la sociedad para
              conservar, restaurar y cuidar estos territorios.
            </p>
          </div>
        </div>
      </div>
    </motion.div>;
}